import React, { useEffect, useState } from 'react'
import { useNavigate  } from 'react-router-dom';
import userContext from '../context/Users/UserContext';
import { useContext } from 'react';
import noteContext from '../context/Notes/NoteContext';


const Login = (props) => {

    const ntcontext = useContext(noteContext)
    const { authtoken,setauthtoken} = ntcontext
    
    const context = useContext(userContext);
    const {setisauthenticated} = context


    let navigate = useNavigate ();

    const [credentials, setcredentials] = useState({ email: "", password: "" })

    const handleclick = async (e) => {
        e.preventDefault();

        const response = await fetch("https://floatnotes.onrender.com/api/auth/login", {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(credentials),
        });

        let json = await response.json()

        if (json.success) {
            
            setisauthenticated(true);
            localStorage.setItem('token', json.authtoken);
            setauthtoken(json.authtoken);
            navigate('/home');
            props.showalert("Login Success","success");

        } else {
            props.showalert("invalid password","danger");
        }

    }

    const onchange = (e) => {
        setcredentials({ ...credentials, [e.target.name]: e.target.value })
    }
    return (
        <>
            <div className="container border shadow rounded p-3 my-5" style={{width:"60vw"}} onSubmit={handleclick}>
                <form>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                        <input type="email" className="form-control" id="email" name="email" onChange={onchange} aria-describedby="emailHelp" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                        <input type="password" className="form-control" id="password" name="password" onChange={onchange} />
                    </div>
                    <button className="btn btn-dark">Login</button>
                </form>
            </div>

        </>
    )
}

export default Login